import { inject, Injectable, Injector } from '@angular/core';
import { WiegungService, WiegungSubmitParams } from './wiegung-service';
import { Order } from '../types/order';
import { Item } from '../types/material';
import { OrderDetail } from '../types/order-detail';
import { SOFTLINE_SERVICE_HTTP, Store } from '@softline/core';
import { WeighParams } from '../types/weigh-params';
import { MessageBarStore, SOFTLINE_FEATURE_MESSAGE_BAR } from '@softline/ui-core';


@Injectable()
export class GesamtwiegungWiegungService extends WiegungService<OrderDetail['artikel']> {
  readonly type = 'GESAMTWIEGEN';
  readonly isMaterialRequired = false;
  readonly isOrderRequired = true;

  constructor() {
    super(inject(SOFTLINE_SERVICE_HTTP), inject(Store), inject(Injector));
    console.log('GesamtWiegungService');
  }

  override async submit({ data, params, orderWeight }: WiegungSubmitParams): Promise<WeighParams | null> {
    if ((params?.gewicht ?? 0) > orderWeight) {
      const material = await this.selectCustomMaterial(data.order.id);

      if (!material || material === "DISMISSED") {
        await this.store.dispatch(
          SOFTLINE_FEATURE_MESSAGE_BAR,
          MessageBarStore.actions.info,
          { title: 'Aufzeichnung abgebrochen!' }
        );
        return null;
      }

      return {
        ...params,
        art: 'MATERIALLIEFERSCHEIN',
        idartstamm: material?.id ?? null,
        menge: (params?.gewicht ?? 0) - orderWeight,
        gewicht: (params?.gewicht ?? 0) - orderWeight,
        arteh: {
          id: 13,
          arteh: 'g'
        }
      } as WeighParams;
    } else if (((params?.gewicht ?? 0) < orderWeight)) {
      const lighterMaterial = await this.selectCustomLighterMaterial(
        data.material.id,
        params?.gewicht ?? 0
      );

      if (lighterMaterial !== null) {
        return {
          ...params,
          idartstamm: (data.material as any)?.artstamm?.id ?? data?.material.id
        } as WeighParams;
      } else {
        console.log('Aufzeichnung abgebrochen!')
      }
    }

    return null;
  }

  override shouldLoadMaterials(): boolean {
    return true;
  }

  async weighMaterial(material: OrderDetail["artikel"]): Promise<void> {
    return Promise.resolve(undefined);
  }
}